var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComponentFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 16H13C14.6569 16 16 14.6574 16 13.0005V6L10 0H3.00007C1.34322 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16Z",
    fill: "url(#paint0_linear_307_190)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15.75H3C1.48122 15.75 0.25 14.5188 0.25 13V3C0.25 1.48123 1.48128 0.25 3.00007 0.25H9.89645L15.75 6.10355V13.0005C15.75 14.5192 14.5188 15.75 13 15.75Z",
    stroke: "black",
    strokeOpacity: 0.06,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_307_190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4V0L16 6H12C10.8954 6 10 5.10457 10 4Z",
    fill: "url(#paint1_linear_307_190)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 11,
    r: 3,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_307_190",
    x: 8,
    y: -1,
    width: 10,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_307_190"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_307_190",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_307_190",
    x1: 1,
    y1: 1,
    x2: 14.5,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D58FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117896,
    stopColor: "#9C58FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.213837,
    stopColor: "#9959FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2912,
    stopColor: "#955AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353363,
    stopColor: "#8F5BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403704,
    stopColor: "#895DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4456,
    stopColor: "#815FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48243,
    stopColor: "#7861FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51757,
    stopColor: "#6F63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5544,
    stopColor: "#6566FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596296,
    stopColor: "#5B68FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646637,
    stopColor: "#526BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7088,
    stopColor: "#486DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786163,
    stopColor: "#3E70FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882104,
    stopColor: "#3572FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D74FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_307_190",
    x1: 13,
    y1: 3,
    x2: 10,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.514828,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponentFile);
export default __webpack_public_path__ + "static/media/component-file.20da799d1b1a2549503b103bf2ff15b1.svg";
export { ForwardRef as ReactComponent };